import React from "react";
import { useNavigate } from "react-router";
import HeaderDescription from "../../../components/commons/HeaderDescription";
import MOButtonV2 from "../../../components/commons/MOButtonV2";

const InvalidVendor = () => {
  const navigate = useNavigate();

  return (
    <div className="rate-analysis-page">
      <HeaderDescription
        heading="Rate Analysis"
        description="The selected platform was not found."
      />

      <div className="bg-white main-section-spacing border-radius-8 rate-analysis-invalid-vendor">
        <p className="font-14 font-600 m-0 mb-8">Invalid platform</p>
        <p className="font-12 text-light-grey m-0 mb-20">
          Please go back and select a valid platform to continue.
        </p>
        <MOButtonV2
          text="Back to platform selection"
          onClick={() => navigate("/dashboard/rate-analysis")}
          backgroundColor="#29AEE6"
          textColor="#FFFFFF"
          border="none"
          radius={4}
          height={36}
          fontSize={13}
          padding="8px 20px"
        />
      </div>
    </div>
  );
};

export default InvalidVendor;
